(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cust_animated-media"] && !window.DesignMode) return;
  try {
    
  class ScrollSlider extends window.HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector("[data-config]");
      this.config = this.slider.dataset.config;
      this.speed = Number(this.slider.dataset.speed) || 60;
      this.sliderItems = this.querySelectorAll(".tm-item");
      this.sliderWidth = 0;

      // Calculate total width of slider items
      this.sliderItems.forEach(item => {
        this.sliderWidth += item.clientWidth;
      });

      this.sliderWidth = this.clientWidth - this.sliderWidth;
      // Initialize GSAP timeline
      this.tm = gsap.timeline();
      this.init();
    }

    init() {
      this.tm.to(this.slider, {
        x: "-100%",
        duration: this.speed,
        ease: "power1.in", // GSAP easing function
        repeat: -1,
        modifiers: {
          x: gsap.utils.unitize(t => parseFloat(t) % window.innerWidth) // use gsap.utils
        },
        onComplete: () => {
          const rect = this.getBoundingClientRect();
          console.log(rect);
        }
      });

      this.addEventListener("mouseenter", () => {
        this.tm.pause();
      });

      this.addEventListener("mouseleave", () => {
        this.tm.play();
      });
    }

    // New method to update speed
    setSpeed(newSpeed) {
      this.speed = newSpeed;
      this.tm.timeScale(newSpeed / 60); // Adjust the timeline speed
    }

    // New method to reset the slider
    resetSlider() {
      this.tm.restart();
    }
  }

  // Define the custom element
  if (!window.customElements.get("scroll-slider")) {
    window.customElements.define("scroll-slider", ScrollSlider);
  }


  document.addEventListener("DOMContentLoaded", function() {
    // Initialize the tooltip

    // Add event listener for window resize
    window.addEventListener("resize", function() {
      // Re-initialize the tooltip on resize
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_benefit-box-content"] && !window.DesignMode) return;
  try {
    
  function initTooltip() {
    const tooltip = document.querySelectorAll('[data-js-tooltip]');
    const tooltipMobile = document.querySelectorAll('[data-js-tooltip-mobile]');
    let tooltipVisible = false; // Flag to track tooltip visibility

    if (tooltip || tooltipMobile) {
      // Use click event for mobile
      tooltipMobile.forEach(function(tooltip) {
        tooltip.addEventListener('click', function() {
          console.log('click');
          const content = tooltip.closest('[data-js-tooltip-container]').querySelector('[data-js-tooltip-content]');
          tooltipVisible = !tooltipVisible; // Toggle the flag
          content.classList.toggle('cust-benefit-box-content__info-box--visible', tooltipVisible);

          // Add event listener for click the box
          content.addEventListener('click', function() {
            tooltipVisible = false; // Reset the flag
            content.classList.remove('cust-benefit-box-content__info-box--visible');
          });
        });
      });

      // Use mouseover/mouseout for desktop
      tooltip.forEach(function(tooltip) {
        tooltip.addEventListener('mouseover', function() {
          console.log('mouseover');
          const content = tooltip.closest('[data-js-tooltip-container]').querySelector('[data-js-tooltip-content]');
          content.classList.add('cust-benefit-box-content__info-box--visible');
        });
        tooltip.addEventListener('mouseout', function() {
          console.log('mouseout');
          const content = tooltip.closest('[data-js-tooltip-container]').querySelector('[data-js-tooltip-content]');
          content.classList.remove('cust-benefit-box-content__info-box--visible');
        });
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function() {
    // Initialize the tooltip
    initTooltip();

    // Add event listener for window resize
    window.addEventListener("resize", function() {
      // Re-initialize the tooltip on resize
      initTooltip();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_faq-with-image"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('[data-item]');
    items.forEach(item => {
      item.addEventListener('click', function() {
        this.classList.toggle('active');
        items.forEach(otherItem => {
          if (otherItem !== this) {
            otherItem.classList.remove('active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
